import { forwardRef } from 'react';
import SlickSlider, { Settings } from 'react-slick';

import * as S from './styles';

export type SliderSettings = Settings;

export type SliderProps = {
  children: React.ReactNode;
  settings: SliderSettings;
  hasMoreThanOne: boolean;
};

export const Slider = forwardRef<SlickSlider, SliderProps>(
  ({ children, settings, hasMoreThanOne }, ref) => (
    <S.Wrapper hasMoreThanOne={hasMoreThanOne}>
      <SlickSlider ref={ref} {...settings}>
        {children}
      </SlickSlider>
    </S.Wrapper>
  )
);
